import { Star } from "lucide-react";

export function Stars({ rating = 0, size = 14, showNumber = true, count }) {
  const r = Number(rating) || 0;
  return (
    <div className="flex items-center gap-1" data-testid="rating-stars">
      <div className="flex">
        {[1, 2, 3, 4, 5].map((i) => (
          <Star key={i} size={size}
            className={i <= Math.round(r) ? "fill-[#E07A5F] text-[#E07A5F]" : "text-[#D8CFBC]"} />
        ))}
      </div>
      {showNumber && <span className="text-xs font-semibold text-[#5A626A]">{r > 0 ? r.toFixed(1) : "New"}{count != null && r > 0 ? ` (${count})` : ""}</span>}
    </div>
  );
}
